import TopicAPI from '@/apis/business/common/topic-api.js'

export default {
  namespaced: true,

  state: {
    topics: []
  },

  getters: {},

  mutations: {
    /**
     * @description set dữ liệu cho state classrooms
     * @author PBac
     * @param {*} state
     * @param {*} classRooms
     */
    setTopics (state, topics) {
      state.topics = topics
    }
  },

  actions: {
    /**
     * @author PBac
     * @param {*} context
     * @param {object} params GradeID - ID khối; SubjectCode - Mã môn học
     * @description Lấy danh sách Topic
     */
    getTopics (context, query) {
      return TopicAPI.getAsync(`filter/grade-subject?${query}`)
    }
  }
}
